import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdAttachFile, MdCamera, MdClose, MdDelete, MdDrafts, MdFileCopy, MdFilePresent, MdOutlineDrafts, MdSave, MdSaveAlt, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { apiKey_g, MAX_FILE_SIZE, MAX_FILE_SIZE_OCR, researcherMailConst, web_url, WORD_LIMIT } from "../../constant";

function EmailCompose({ lang }) {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^(?!.*script)[a-z0-9.]{7,}$/i;

    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });


    const handleChange = (value) => {
        // console.log(value);
        setEmailcomposeDetails((prev) => ({ ...prev, body: value }))
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    const [recepientMails, setRecepientMails] = useState({
        penpal: "",
        teacher: '',
        admin: ''
    })

    const navigate = useNavigate();
    const [recepientArray, setRecepientArray] = useState(['Penpal', 'Teacher', 'Admin']);

    useEffect(() => {
        if (localStorage.getItem('penpalEmail') === "empty") {
            setRecepientArray(['Teacher', 'Admin'])
        } else {
            setRecepientArray(['Penpal', 'Teacher', 'Admin'])
        }
    }, [])

    const [emailcomposeDetails, setEmailcomposeDetails] = useState(
        {
            threadId: '',
            toRole: '',
            to: '',
            subject: '',
            body: '',
        }
    )

    const [errors, setErrors] = useState(
        {
            noToRole: false,
            noTo: false,
            noBody: false,
            invalidTo: false,
            wordLimitExceeded: false
        }
    )

    const [files, setFiles] = useState([]);

    const [OCRfiles, setOCRFiles] = useState([]);

    const [showRoleInput, setShowRoleInput] = useState(true)
    const mobileFileInputRef = useRef(null);
    const desktopFileInputRef = useRef(null);

    const desktopOCRFileInputRef = useRef(null);
    const mobileOCRFileInputRef = useRef(null);

    const handleFileChange = (e) => {

        if (e.target.files) {
            const fileArray = Array.from(e.target.files); // Convert FileList to array
            const validFiles = fileArray.filter((file) => {

                if (file.size <= MAX_FILE_SIZE) {
                    return true;
                } else {
                    alert(`File "${file.name}" is larger than 5MB and will be skipped.`);
                    return false;
                }
            });

            setFiles((prevFiles) => [...prevFiles, ...validFiles]);
            e.target.value = "";
        }
    };

    const handleFileUpload = async (event) => {


        const file = event.target.files[0];

        if (!file) return;

        if (!file.type.startsWith("image/")) {
            alert("Please upload a valid image file.");
            return;
        }

        setOpen2(true);
        const reader = new FileReader();

        reader.onloadend = async () => {
            const base64Image = reader.result.replace("data:image/jpeg;base64,", "").replace("data:image/png;base64,", "");

            const apiKey = apiKey_g;
            const body = {
                requests: [
                    {
                        image: { content: base64Image },
                        features: [{ type: "DOCUMENT_TEXT_DETECTION" }],
                    },
                ],
            };

            event.target.value = "";
            try {
                const res = await fetch(
                    `https://vision.googleapis.com/v1/images:annotate?key=${apiKey_g}`,
                    {
                        method: "POST",
                        body: JSON.stringify(body),
                        headers: { "Content-Type": "application/json" },
                    }
                );

                const data = await res.json();
                const text = data.responses?.[0]?.fullTextAnnotation?.text || "No text found.";
                setResult(text);
                setEmailcomposeDetails((prev) => ({ ...prev, body: text }));
                setOpen2(false);
            } catch (error) {
                setOpen2(false);
                console.error("Vision API error:", error);
                // alert("Error sending image to Google Vision API.");
            }
        };

        reader.readAsDataURL(file); // Convert file to base64
    };


    // const handleFileChangeOCR = (e) => {

    //     if (e.target.files) {
    //         const fileArray = Array.from(e.target.files); // Convert FileList to array
    //         const validFiles = fileArray.filter((file) => {

    //             if (file.size <= MAX_FILE_SIZE_OCR) {
    //                 return true;
    //             } else {
    //                 alert(`File "${file.name}" is larger than 5MB and will be skipped.`);
    //                 return false;
    //             }
    //         });

    //         setOCRFiles(() => [...validFiles]);
    //         e.target.value = "";
    //     }
    // };

    const removeFile = (fileToRemove) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    };

    const [isSubjectNew, setIsSubjectNew] = useState(false);
    const [isDraft, setIsDraft] = useState(false)
    const [initialType, setInitialType] = useState('no');
    const [threadId, setThreadId] = useState('no');
    const [messageId, setMessageId] = useState('no');

    const [showCamera, setShowCamera] = useState(false);
    const [showOCRoptions, setShowOCRoptions] = useState(false);

    useEffect(() => {
        // console.log('this 100');
        if (localStorage.getItem('threadId')) {
            const mailRequest = JSON.parse(localStorage.getItem('threadId'));
            if (mailRequest.type === "new") {
                setInitialType("new");
                setIsDraft(false);
                setIsSubjectNew(true);
                setEmailcomposeDetails({
                    threadId: '',
                    toRole: '',
                    to: '',
                    subject: '',
                    body: '',
                })
            } else if (mailRequest.type === "old") {
                setInitialType("old");
                // console.log('this 2');
                setIsDraft(false);
                setIsSubjectNew(false);
                const type = mailRequest.role;
                let roleToNow = "";
                if (type === "PENPAL") {
                    roleToNow = "Penpal"
                } else if (type === "ADMIN" || mailRequest.to === researcherMailConst) {
                    roleToNow = "Admin"
                } else {
                    roleToNow = "Teacher"
                }
                // console.log("to", mailRequest.to);
                setEmailcomposeDetails((prev) => ({
                    ...prev,
                    subject: mailRequest.subject.trim() !== "" ? `${mailRequest.subject}` : " ",
                    threadId: mailRequest.threadId,
                    to: mailRequest.to,
                    toRole: roleToNow
                }))
                setShowRoleInput(false)
            }
        } else {
            setInitialType("no");
            // console.log('this 101');

            if (localStorage.getItem('messagePenpal')) {

                if (localStorage.getItem('messagePenpal') === 'true') {
                    setIsDraft(false);
                    setIsSubjectNew(true);
                    setEmailcomposeDetails((prev) => ({
                        ...prev,
                        subject: "",
                        toRole: 'Penpal',
                        to: localStorage.getItem('penpalEmail')
                    }))

                    setShowRoleInput(false)
                } else {
                    setIsDraft(false);
                    setIsSubjectNew(true);
                    setEmailcomposeDetails({
                        threadId: '',
                        toRole: '',
                        to: '',
                        subject: '',
                        body: '',
                    })
                    setShowRoleInput(true)
                }
            } else {

                setIsDraft(false);
                setIsSubjectNew(true);
                setEmailcomposeDetails({
                    threadId: '',
                    toRole: '',
                    to: '',
                    subject: '',
                    body: '',
                })
                setShowRoleInput(true)
            }

        }
    }, [localStorage.getItem('threadId')])


    useEffect(() => {
        if (localStorage.getItem('threadId')) {
            const mailRequest = JSON.parse(localStorage.getItem('threadId'));
            if (mailRequest.type === "draft") {
                setInitialType("draft");
                setThreadId(mailRequest.threadId);
                setMessageId(mailRequest.messageId);
                setIsDraft(true);
                setIsSubjectNew(true);
                setShowRoleInput(true);
                setFiles(mailRequest.attachments || [])
                const type = mailRequest.type;
                let roleToNow = "";
                console.log('role', mailRequest.role);

                if (mailRequest.role === "PENPAL") {
                    roleToNow = "Penpal"
                } else if (mailRequest.role === "ADMIN") {
                    roleToNow = "Admin"
                } else {
                    roleToNow = "Teacher"
                }
                setEmailcomposeDetails((prev) => ({
                    ...prev,
                    subject: mailRequest.subject.trim() !== "" ? `${mailRequest.subject}` : " ",
                    threadId: mailRequest.threadId,
                    to: mailRequest.to,
                    body: mailRequest.body,
                    toRole: roleToNow
                }))

            }
        }
    }, [localStorage.getItem('threadId')])


    useEffect(() => {

        if (localStorage.getItem('school')) {

            setOpen2(true);

            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const config = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };

            axios.get(`${web_url}/api/auth/researchers`, config).then((responseNew) => {
                const adminEmail = (responseNew.data)[0].userEmail;
                const teacherEmail = localStorage.getItem('teacherEmail');
                setRecepientMails({
                    penpal: localStorage.getItem('penpalEmail'),
                    teacher: teacherEmail,
                    admin: adminEmail
                })

                setOpen2(false);
            }).catch((err2) => {

                if (err2.response) {

                    if (err2.response.data.error) {
                        handleClickOpenError(err2.response.data.error);
                    } else if (err2.response.data.message) {
                        handleClickOpenError(err2.response.data.message);
                    } if (err2.response.data.token) {
                        handleClickOpenError(err2.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setOpen2(false);
            })
        }
    }, [])



    const handleSend = () => {
        console.log(emailcomposeDetails);

        let newErrors = []
        const strippedText = emailcomposeDetails.body.replace(/<[^>]*>/g, "").trim();
        newErrors.noBody = !strippedText;
        newErrors.noTo = !emailcomposeDetails.to;
        newErrors.noToRole = !emailcomposeDetails.toRole.trim();


        if ((emailcomposeDetails.to) && !emailRegex.test(emailcomposeDetails.to) && !nameRegex.test(emailcomposeDetails.to)) {
            newErrors.invalidTo = true;
        } else {
            newErrors.invalidTo = false;
        }


        const strippedText2 = emailcomposeDetails.body
            .replace(/<[^>]*>/g, " ")
            .replace(/\s+/g, " ")
            .trim();

        const words = strippedText2
            .split(" ")
            .filter(word => word.length > 0);

        if (words.length > WORD_LIMIT) {
            newErrors.wordLimitExceeded = true;
        } else {
            newErrors.wordLimitExceeded = false;
        }

        setErrors(newErrors);


        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        console.log('sentMessagesPerWeek 1', localStorage.getItem('sentMessagesPerWeek'));
        if (localStorage.getItem('sentMessagesPerWeek') && emailcomposeDetails.toRole === "Penpal") {
            const sentMessagesPerWeek = parseInt(localStorage.getItem('sentMessagesPerWeek'));
            if (sentMessagesPerWeek >= 3) {
                handleClickOpenError('limit exceeded');
                setIsLoading(false);
                return;
            }
        }

        if (emailcomposeDetails.toRole === "Admin" || emailcomposeDetails.toRole === "Penpal") {


            setIsLoading(true);

            const textAttr = {
                q: emailcomposeDetails.body,
                target: "en",
                format: "html",
            }

            const textAttr2 = {
                q: emailcomposeDetails.subject.trim(),
                target: "en",
                format: "html",
            }

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            axios.post(
                `https://translation.googleapis.com/language/translate/v2?key=${apiKey_g}`,
                textAttr, config
            ).then((response) => {
                if (emailcomposeDetails.subject.trim()) {
                    axios.post(
                        `https://translation.googleapis.com/language/translate/v2?key=${apiKey_g}`,
                        textAttr2, config
                    ).then((response2) => {
                        setIsLoading(false);
                        setTranslatedMessage(response.data.data.translations[0].translatedText)
                        setTranslatedSubject(response2.data.data.translations[0].translatedText)
                        if (isSubjectNew && !isDraft) {


                            sendEmail(response.data.data.translations[0].translatedText, response2.data.data.translations[0].translatedText)

                        } else {

                            updateMail(response.data.data.translations[0].translatedText, response2.data.data.translations[0].translatedText);
                        }
                    }).catch((err2) => {
                        setIsLoading(false);
                        handleClickOpenError("error occured")
                    })
                } else {
                    setIsLoading(false);
                    setTranslatedMessage(response.data.data.translations[0].translatedText);
                    if (isSubjectNew && !isDraft) {

                        sendEmail(response.data.data.translations[0].translatedText)

                    } else {

                        updateMail(response.data.data.translations[0].translatedText);
                    }

                }

            }).catch((err) => {
                setIsLoading(false);
                handleClickOpenError("error occured")
            })

        } else {
            if (isSubjectNew && !isDraft) {
                // console.log('this is done for darft  -1');

                sendEmail()
                // sendNewMail();
            } else {
                // console.log('this is done for darft  -2');
                updateMail();
            }
        }
    }


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else if (err.toLowerCase().includes('receiver email and body cannot be empty')) {
            setError(t('t219'));
        } else if (err.toLowerCase().includes('limit exceeded')) {
            setError(t('t438'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };


    const [open10, setOpen10] = useState(false)

    const handleClose10 = () => {
        setOpen10(false);
    }

    const [translatedMessage, setTranslatedMessage] = useState("")
    const [translatedSubject, setTranslatedSubject] = useState("")


    const sendEmail = (translatedBodyT = "NA", translatedSubjectT = "startMes") => {

        setOpen2(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        let language = "English";
        let type = "NONE";
        let apiUrl = "";
        if (emailcomposeDetails.toRole === "Penpal") {

            apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
        } else if (emailcomposeDetails.toRole === "Teacher") {

            apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
        } else if (emailcomposeDetails.toRole === "Admin") {

            apiUrl = `${web_url}/api/auth/researchers/${emailcomposeDetails.to}`
        }

        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const config = {
            headers: {
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };

        axios.get(apiUrl, config).then((response) => {
            if (emailcomposeDetails.toRole === "Penpal") {
                language = response.data.preferredLanguage;
            } else {
                language = "English";
            }

            if (emailcomposeDetails.toRole === "Penpal") {
                type = "PENPAL"
            } else if (emailcomposeDetails.toRole === "Admin") {
                type = "ADMIN"
            } else {
                type = "NONE"
            }

            const formData = new FormData();
            let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";
            formData.append("sender", logDetails.email);
            formData.append("recipient", emailcomposeDetails.to);
            formData.append("subject", subject);
            formData.append("body", emailcomposeDetails.body);
            formData.append("language", language);
            formData.append("isDraft", "FALSE");
            formData.append("type", type);

            if (files && files.length > 0) {
                files.forEach((file) => {
                    formData.append("attachments", file);
                });
            }

            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };
            // console.log('fd', formData);

            if (emailcomposeDetails.toRole === "Admin") {
                formData.append("translatedBody", translatedBodyT);
                formData.append("translatedSubject", translatedSubjectT);
            } else {
                formData.append("translatedBody", "NA");
                formData.append("translatedSubject", "startMes");
            }

            if (emailcomposeDetails.toRole === "Penpal") {
                formData.append("englishBody", translatedBodyT);
                formData.append("englishSubject", translatedSubjectT);
            } else {
                formData.append("englishBody", "NA");
                formData.append("englishSubject", "NA");
            }


            axios.post(`${web_url}/api/email-threads`, formData, config)
                .then((response) => {
                    if (localStorage.getItem('sentMessagesPerWeek') && emailcomposeDetails.toRole === "Penpal") {
                        let sentMessagesPerWeek = parseInt(localStorage.getItem('sentMessagesPerWeek'));
                        sentMessagesPerWeek += 1;
                        localStorage.setItem('sentMessagesPerWeek', sentMessagesPerWeek.toString());
                    }
                    const getLogDetails2 = () => {
                        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                    };
                    const logDetails2 = getLogDetails2();

                    const config = {
                        headers: {
                            'Authorization': `Bearer ${logDetails2.token}`,
                        },
                    };

                    if (initialType === "draft") {

                        axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, config).then((response) => {
                            localStorage.setItem("refresh", `${Date.now()}`);
                            localStorage.setItem('draft type', "finished");
                            setInitialType('no')
                            setOpen2(false);
                            setOpen4(true);

                        }).catch((err) => {
                            setOpen2(false);

                            if (err.response.data.message) {
                                if (err.response.data.message === "Message id not found!") {
                                    setEmailcomposeDetails({
                                        threadId: '',
                                        toRole: '',
                                        to: "",
                                        subject: '',
                                        body: '',
                                    })
                                } else {

                                    handleClickOpenError("error occured")
                                }
                            } else {

                                handleClickOpenError("error occured")
                            }
                        })
                    } else {

                        setOpen2(false);

                        setOpen4(true);


                    }
                })
                .catch((err) => {

                    if (err.response) {
                        // console.log(err.response)
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } if (err.response.data.token) {
                            handleClickOpenError(err.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                    setOpen2(false);
                })

        }).catch((err) => {
            setOpen2(false);
            // console.log("err", err)
            if (err.response.data.message) {
                handleClickOpenError(err.response.data.message);
            } else {
                handleClickOpenError("Error occured")
            }
        })

    };

    const saveDraft = () => {
        setOpen3(false);
        if (emailcomposeDetails.toRole.trim() && emailcomposeDetails.body.trim()) {
            setErrors((prev) => ({ ...prev, noBody: false, noToRole: false }));
            if (isSubjectNew) {
                // console.log('this is done');

                setOpen2(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();
                let language = "English";
                let type = "NONE";
                let apiUrl = "";
                if (emailcomposeDetails.toRole === "Penpal") {
                    apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
                } else if (emailcomposeDetails.toRole === "Teacher") {
                    apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
                } else if (emailcomposeDetails.toRole === "Admin") {
                    apiUrl = `${web_url}/api/auth/researchers/${emailcomposeDetails.to}`
                }

                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };

                axios.get(apiUrl, configToken).then((response) => {
                    if (emailcomposeDetails.toRole === "Penpal") {
                        language = response.data.preferredLanguage;
                    } else {
                        language = "English";
                    }

                    if (emailcomposeDetails.toRole === "Penpal") {
                        type = "PENPAL"
                    } else if (emailcomposeDetails.toRole === "Admin") {
                        type = "ADMIN"
                    } else {
                        type = "NONE"
                    }

                    const formData = new FormData();
                    let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

                    formData.append("sender", logDetails.email);
                    formData.append("recipient", emailcomposeDetails.to);
                    formData.append("subject", subject);
                    formData.append("body", emailcomposeDetails.body);
                    formData.append("language", language);
                    formData.append("isDraft", "TRUE");
                    formData.append("type", type);
                    formData.append("translatedBody", "NA");
                    formData.append("translatedSubject", "startMes");
                    formData.append("englishBody", "NA");
                    formData.append("englishSubject", "NA");

                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append("attachments", file);
                        });
                    }

                    const getLogDetails2 = () => {
                        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                    };
                    const logDetails2 = getLogDetails2();

                    const config = {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            'Authorization': `Bearer ${logDetails2.token}`,
                        },
                    };

                    axios.post(`${web_url}/api/email-threads`, formData, config)
                        .then((response) => {
                            if (initialType === "draft") {
                                const getLogDetails2 = () => {
                                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                                };
                                const logDetails2 = getLogDetails2();

                                const configToken = {
                                    headers: {
                                        'Authorization': `Bearer ${logDetails2.token}`,
                                    },
                                };
                                axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                                    localStorage.setItem("refresh", `${Date.now()}`);
                                    localStorage.setItem('draft type', "finished");
                                    setInitialType('no')
                                    setOpen2(false);
                                    setOpen5(true);
                                }).catch((err) => {
                                    setOpen2(false);
                                    if (err.response.data.message) {
                                        if (err.response.data.message === "Message id not found!") {
                                            setEmailcomposeDetails({
                                                threadId: '',
                                                toRole: '',
                                                to: "",
                                                subject: '',
                                                body: '',
                                            })
                                        } else {
                                            handleClickOpenError("error occured")
                                        }
                                    } else {
                                        handleClickOpenError("error occured")
                                    }
                                })
                            } else {
                                setOpen2(false);
                                setOpen5(true);

                            }
                        })
                        .catch((err) => {
                            console.log("e4", err)
                            if (err.response) {
                                // console.log(err.response)
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                            setOpen2(false);
                        })

                }).catch((err) => {
                    setOpen2(false);
                    // console.log("err", err)
                    if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("Error occured")
                    }
                })
            } else {
                setOpen2(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();
                let language = "English";
                let type = "NONE";
                let apiUrl = "";
                if (emailcomposeDetails.toRole === "Penpal") {
                    apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
                } else if (emailcomposeDetails.toRole === "Teacher") {
                    apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
                } else if (emailcomposeDetails.toRole === "Admin") {
                    apiUrl = `${web_url}/api/auth/researchers/${emailcomposeDetails.to}`
                }

                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };

                axios.get(apiUrl, configToken).then((response) => {
                    if (emailcomposeDetails.toRole === "Penpal") {
                        language = response.data.preferredLanguage;
                    } else {
                        language = "English";
                    }

                    if (emailcomposeDetails.toRole === "Penpal") {
                        type = "PENPAL"
                    } else if (emailcomposeDetails.toRole === "Admin") {
                        type = "ADMIN"
                    } else {
                        type = "NONE"
                    }

                    const formData = new FormData();
                    let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

                    formData.append("sender", logDetails.email);
                    formData.append("body", emailcomposeDetails.body);
                    formData.append("language", language);
                    formData.append("isDraft", "TRUE");
                    formData.append("type", type);
                    formData.append("translatedBody", "NA");
                    formData.append("englishBody", "NA");


                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append("attachments", file);
                        });
                    }

                    const getLogDetails2 = () => {
                        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                    };
                    const logDetails2 = getLogDetails2();

                    const config = {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            'Authorization': `Bearer ${logDetails2.token}`
                        },
                    };

                    axios.post(`${web_url}/api/email-threads/${emailcomposeDetails.threadId}/add-message`, formData, config)
                        .then((response) => {
                            if (initialType === "draft") {
                                console.log('this is done for darft  -3');
                                const getLogDetails2 = () => {
                                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                                };
                                const logDetails2 = getLogDetails2();

                                const configToken = {
                                    headers: {
                                        'Authorization': `Bearer ${logDetails2.token}`,
                                    },
                                };

                                axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                                    localStorage.setItem("refresh", `${Date.now()}`);
                                    localStorage.setItem('draft type', "finished");
                                    setInitialType('no')
                                    setOpen2(false);
                                    setOpen5(true);
                                }).catch((err) => {
                                    setOpen2(false);
                                    if (err.response.data.message) {
                                        if (err.response.data.message === "Message id not found!") {
                                            setEmailcomposeDetails({
                                                threadId: '',
                                                toRole: '',
                                                to: "",
                                                subject: '',
                                                body: '',
                                            })
                                        } else {
                                            handleClickOpenError("error occured")
                                        }
                                    } else {
                                        handleClickOpenError("error occured")
                                    }
                                })
                            } else {
                                console.log('this is done for darft  -2');
                                setOpen2(false);
                                setOpen5(true);

                            }
                        })
                        .catch((err) => {
                            console.log("e1", err)
                            if (err.response) {
                                // console.log(err.response)
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                            setOpen2(false);
                        })

                }).catch((err) => {
                    setOpen2(false);
                    // console.log("err", err)
                    if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("Error occured")
                    }
                })
            }
        } else if (!emailcomposeDetails.body) {
            setErrors((prev) => ({ ...prev, noBody: true }))
        } else if (!emailcomposeDetails.toRole) {
            setErrors((prev) => ({ ...prev, noToRole: true }))
        }

    };

    const updateMail = (translatedBodyT = "NA", translatedSubjectT = "startMes") => {
        setOpen2(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        let language = "English";
        let type = "NONE";
        let apiUrl = "";
        // console.log(emailcomposeDetails);

        if (emailcomposeDetails.toRole === "Penpal") {
            apiUrl = `${web_url}/api/auth/students/${emailcomposeDetails.to}`
        } else if (emailcomposeDetails.toRole === "Teacher") {
            apiUrl = `${web_url}/api/auth/teachers/${emailcomposeDetails.to}`
        } else if (emailcomposeDetails.toRole === "Admin") {
            apiUrl = `${web_url}/api/auth/researchers/${emailcomposeDetails.to}`
        }

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };


        axios.get(apiUrl, configToken).then((response) => {
            if (emailcomposeDetails.toRole === "Penpal") {
                language = response.data.preferredLanguage;
            } else {
                language = "English";
            }

            if (emailcomposeDetails.toRole === "Penpal") {
                type = "PENPAL"
            } else if (emailcomposeDetails.toRole === "Admin") {
                type = "ADMIN"
            } else {
                type = "NONE"
            }

            const formData = new FormData();
            let subject = emailcomposeDetails.subject ? emailcomposeDetails.subject : " ";

            formData.append("sender", logDetails.email);
            formData.append("body", emailcomposeDetails.body);
            formData.append("language", language);
            formData.append("isDraft", "FALSE");
            formData.append("type", type);

            if (emailcomposeDetails.toRole === "Admin") {
                formData.append("translatedBody", translatedBodyT);
            } else {
                formData.append("translatedBody", "NA");
            }

            if (emailcomposeDetails.toRole === "Penpal") {
                formData.append("englishBody", translatedBodyT);
            } else {
                formData.append("englishBody", "NA");
            }

            if (files && files.length > 0) {
                files.forEach((file) => {
                    formData.append("attachments", file);
                });
            }

            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };

            axios.post(`${web_url}/api/email-threads/${emailcomposeDetails.threadId}/add-message`, formData, config)
                .then((response) => {
                    if (localStorage.getItem('sentMessagesPerWeek') && emailcomposeDetails.toRole === "Penpal") {
                        let sentMessagesPerWeek = parseInt(localStorage.getItem('sentMessagesPerWeek'));
                        sentMessagesPerWeek += 1;
                        localStorage.setItem('sentMessagesPerWeek', sentMessagesPerWeek.toString());
                    }
                    if (initialType === "draft") {
                        const getLogDetails2 = () => {
                            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                        };
                        const logDetails2 = getLogDetails2();

                        const configToken = {
                            headers: {
                                'Authorization': `Bearer ${logDetails2.token}`,
                            },
                        };

                        axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                            localStorage.setItem("refresh", `${Date.now()}`);
                            localStorage.setItem('draft type', "finished");
                            setInitialType('no')
                            setOpen2(false);
                            setOpen4(true);
                        }).catch((err) => {
                            setOpen2(false);
                            if (err.response.data.message) {
                                if (err.response.data.message === "Message id not found!") {
                                    setEmailcomposeDetails({
                                        threadId: '',
                                        toRole: '',
                                        to: "",
                                        subject: '',
                                        body: '',
                                    })
                                } else {
                                    handleClickOpenError("error occured")
                                }
                            } else {
                                handleClickOpenError("error occured")
                            }
                        })
                    } else {
                        setOpen2(false);
                        setOpen4(true);

                    }
                })
                .catch((err) => {
                    console.log("e2", err)
                    if (err.response) {
                        // console.log(err.response)
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } if (err.response.data.token) {
                            handleClickOpenError(err.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                    setOpen2(false);
                })

        }).catch((err) => {
            setOpen2(false);
            // console.log("err", err)
            if (err.response.data.message) {
                handleClickOpenError(err.response.data.message);
            } else {
                handleClickOpenError("Error occured")
            }
        })
    }


    const [open2, setOpen2] = useState(false)

    const handleClose2 = () => {
        setOpen2(false);
    }

    const [open3, setOpen3] = useState(false)

    const handleClose3 = () => {
        setOpen3(false);
    }

    const [open4, setOpen4] = useState(false)

    const handleClose4 = () => {
        setOpen4(false);
        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/student/mailbox')
        } else {
            navigate('/mobile/student/mailbox')
        }
    }

    const [openDraft, setOpenDraft] = useState(false)

    const handleCloseDraft = () => {
        setOpenDraft(false);

        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/student/mailbox')
        } else {
            navigate('/mobile/student/mailbox')
        }
    }

    const [open5, setOpen5] = useState(false)

    const handleClose5 = () => {
        setOpen5(false);
        if (isXlOrLarger) {
            const mailRequest = {
                type: 'new',
                subject: 'nothing'
            };
            setEmailcomposeDetails({
                threadId: '',
                toRole: '',
                to: '',
                subject: '',
                body: '',
            })
            setFiles([])
            localStorage.setItem('threadId', JSON.stringify(mailRequest));
            localStorage.setItem("refresh", `${Date.now()}`);
            navigate('/desktop/student/mailbox')
        } else {
            navigate('/mobile/student/mailbox')
        }
    }

    const handleDeleteDraft = () => {
        setOpen2(true);
        if (initialType === "draft") {
            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };

            axios.delete(`${web_url}/api/email-threads/${threadId}/messages/${messageId}`, configToken).then((response) => {
                localStorage.setItem("refresh", `${Date.now()}`);
                localStorage.setItem('draft type', "finished");
                setInitialType('no')
                setOpen2(false);
                setOpenDraft(true);
            }).catch((err) => {
                setOpen2(false);
                if (err.response.data.message) {
                    if (err.response.data.message === "Message id not found!") {
                        setEmailcomposeDetails({
                            threadId: '',
                            toRole: '',
                            to: "",
                            subject: '',
                            body: '',
                        })
                    } else {
                        handleClickOpenError("error occured")
                    }
                } else {
                    handleClickOpenError("error occured")
                }
            })
        } else {
            setOpen2(false);
        }
    }

    const isMobileDevice = () => {
        const ua = navigator.userAgent;

        // Check for common mobile & tablet devices
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(ua);

        // Detect iPadOS (some iPads report as Macintosh but have touch support)
        const isIPad =
            /Macintosh/i.test(ua) &&
            ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
            !navigator.platform.includes('MacIntel') &&
            !/Mac OS X/.test(ua); // Exclude Mac ARM (M1/M2 Macs)

        return isMobile || isTablet || isIPad;
    };

    useEffect(() => {
        let sentMessagesPerWeek = 0;
        if (localStorage.getItem("sentMessagesPerWeek")) {
            sentMessagesPerWeek = parseInt(localStorage.getItem("sentMessagesPerWeek"));
            if (sentMessagesPerWeek >= 3 && emailcomposeDetails.toRole === "Penpal") {
                handleClickOpenError('limit exceeded');
                setEmailcomposeDetails((prev) => ({ ...prev, toRole: '' }));
                setIsLoading(false);
                return;
            }
        }
        if (emailcomposeDetails.toRole === "Penpal") {
            setShowOCRoptions(true);
        } else {
            setShowOCRoptions(false);
        }
    }, [emailcomposeDetails.toRole])

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [result, setResult] = useState("");
    const [showCameraModal, setShowCameraModal] = useState(false);

    const openCamera = async () => {
        try {
            setShowCameraModal(true);
            setTimeout(async () => {
                const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
                if (videoRef.current) {
                    console.log('streaming');

                    videoRef.current.srcObject = stream;
                } else {
                    console.log('not streaming');
                }
            }, 100);

        } catch (err) {
            alert("Error accessing camera.");
            console.error(err);
        }
    };

    const closeModal = () => {
        const stream = videoRef.current?.srcObject;
        if (stream && typeof stream.getTracks === "function") {
            stream.getTracks().forEach((track) => track.stop());
            console.log("closed");

        }
        setShowCameraModal(false);
    };

    const captureAndSend = async () => {

        const canvas = canvasRef.current;
        const video = videoRef.current;
        const context = canvas.getContext("2d");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const dataURL = canvas.toDataURL("image/jpeg");
        const base64Image = dataURL.replace("data:image/jpeg;base64,", "");
        setOpen2(true);

        const body = {
            requests: [
                {
                    image: { content: base64Image },
                    features: [{ type: "DOCUMENT_TEXT_DETECTION" }],
                },
            ],
        };

        try {
            const res = await fetch(
                `https://vision.googleapis.com/v1/images:annotate?key=${apiKey_g}`,
                {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: { "Content-Type": "application/json" },
                }
            );

            const data = await res.json();
            const text = data.responses?.[0]?.fullTextAnnotation?.text || "No text found.";
            setResult(text);
            setEmailcomposeDetails((prev) => ({ ...prev, body: text }));
            setOpen2(false);
        } catch (error) {
            setOpen2(false);
            console.log("Error sending image to Google Vision API");

            // alert("Error sending image to Google Vision API.");
        }
        setOpen2(false);
        const stream = videoRef.current?.srcObject;
        if (stream && typeof stream.getTracks === "function") {
            stream.getTracks().forEach((track) => track.stop());
        }

        setShowCameraModal(false);
    };


    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                    <div className="xl:hidden flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "" && (emailRegex.test(emailcomposeDetails.to) || nameRegex.test(emailcomposeDetails.to))) {
                                setOpen3(true)
                            } else {
                                navigate('/mobile/student/mailbox')
                            }
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "" && (emailRegex.test(emailcomposeDetails.to) || nameRegex.test(emailcomposeDetails.to))) {
                                setOpen3(true)
                            } else {
                                navigate('/mobile/student/mailbox')
                            }
                        }} />
                        <p className={`font-bold ml-[10px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{isSubjectNew ? t('t233') : t('t260')}</p>
                    </div>
                    <div className="hidden xl:block flex justify-center items-center w-full">
                        <p className={`font-bold ml-[0px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[17px] 2xl:text-[23px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{isSubjectNew ? t('t233') : t('t260')}</p>
                    </div>
                    {showCameraModal && (
                        <div style={modalStyles.overlay}>
                            <div style={modalStyles.modal}>

                                <video
                                    ref={videoRef}
                                    autoPlay
                                    playsInline
                                    muted
                                    className="w-[100%] h-[80%] rounded-lg object-cover bg-black"
                                />
                                <canvas ref={canvasRef} style={{ display: "none" }} />
                                <div className="flex justify-center mt-[20px] gap-[10px] md:gap-[20px] items-stretch">
                                    <button onClick={captureAndSend} className={`rounded-lg font-bold ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} w-[130px] md:w-[160px] lg:w-[180px] py-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]`}>{t('t437')}</button>
                                    <button onClick={closeModal} className={`rounded-lg font-bold ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} w-[130px] md:w-[160px] lg:w-[180px] py-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]`}>{t('t145')}</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="w-full flex items-center justify-center">
                    <div className="w-full md:w-[600px]">
                        <div className="flex gap-[10px] mt-[20px]">
                            <div className="relative group md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                {/* Icon */}
                                <MdAttachFile
                                    size={20}
                                    className="cursor-pointer"
                                    onClick={() => mobileFileInputRef.current?.click()}
                                />

                                {/* Hidden File Input */}
                                <input
                                    ref={mobileFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileChange}
                                />

                                {/* Tooltip */}
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[12px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>
                            <div className="group relative hidden md:flex 2xl:hidden items-center justify-center border border-[#0E141F] rounded-md p-[8px]">
                                <MdAttachFile
                                    size={25}
                                    className="cursor-pointer"
                                    onClick={() => desktopFileInputRef.current?.click()} // Manually open file input
                                />
                                <input
                                    ref={desktopFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[14px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>
                            <div className="group relative hidden 2xl:flex items-center justify-center border border-[#0E141F] rounded-md px-[12px]">
                                <MdAttachFile
                                    size={35}
                                    className="cursor-pointer"
                                    onClick={() => desktopFileInputRef.current?.click()} // Manually open file input
                                />
                                <input
                                    ref={desktopFileInputRef}
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[15px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t476")}
                                </div>
                            </div>
                            <div className="group relative md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                <MdSave size={20} className="md:hidden "
                                    onClick={() => {
                                        if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                            setOpen3(true)
                                        } else {
                                            handleClickOpenError("receiver email and body cannot be empty")
                                        }
                                    }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[12px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>
                            <div className="group relative hidden md:flex 2xl:hidden items-center justify-center border border-[#0E141F] rounded-md p-[8px]">
                                <MdSave size={25} className="hidden md:block cursor-pointer" onClick={() => {
                                    if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                        setOpen3(true)
                                    } else {
                                        handleClickOpenError("receiver email and body cannot be empty")
                                    }
                                }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[14px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>
                            <div className="group relative hidden 2xl:flex items-center justify-center border border-[#0E141F] rounded-md px-[12px]">
                                <MdSave size={35} className="hidden md:block cursor-pointer" onClick={() => {
                                    if (emailcomposeDetails.to.trim() !== "" && emailcomposeDetails.body.trim() !== "") {
                                        setOpen3(true)
                                    } else {
                                        handleClickOpenError("receiver email and body cannot be empty")
                                    }
                                }} />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[15px] rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
                                    {t("t232")}
                                </div>
                            </div>
                            <div className="relative md:hidden w-full flex items-center justify-end">
                                <button className={`px-[10px] h-full flex items-center justify-center gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600]`}
                                    onClick={handleSend}><MdSend size={19} />{t('t116')}</button>
                            </div>
                            <div className="relative hidden md:flex w-full items-center justify-end">
                                <button className={`px-[10px] h-full flex items-center justify-center gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md xl:py-[10px] 2xl:py-[14px] border border-1  border-[#0E141F] font-[600]`}
                                    onClick={handleSend}><MdSend size={19} />{t('t116')}</button>
                            </div>


                            {
                                initialType === "draft" &&
                                <>
                                    <div className="relative md:hidden border border-[#0E141F] rounded-md p-[8px]">
                                        <MdDelete size={25} className="md:hidden" onClick={handleDeleteDraft} />
                                    </div>
                                    <div className="relative hidden md:block border border-[#0E141F] rounded-md p-[8px]">
                                        <MdDelete size={30} className="hidden md:block mr-[70px] xl:mr-[20px] cursor-pointer" onClick={handleDeleteDraft} />
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </div>

                {
                    isSubjectNew &&
                    <>
                        <div className="items-center mt-[20px] md:mt-[40px] xl:mt-[10px] flex h-[50px]  md:h-[60px] xl:h-[50px] 2xl:h-[60px] justify-center">
                            <Menu as="div" className="w-full md:w-[600px] relative inline-block text-left py-[20px]">
                                <div>
                                    <MenuButton
                                        className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${emailcomposeDetails.toRole === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                    >
                                        <p className="pr-[10px] text-gray-500">{t('t220')}:</p>
                                        {emailcomposeDetails.toRole.trim() === "" ? t('t293') : emailcomposeDetails.toRole}
                                        <ChevronDownIcon
                                            aria-hidden="true"
                                            className="absolute right-[10px] size-5 text-gray-700"
                                        />
                                    </MenuButton>
                                </div>

                                <MenuItems
                                    transition
                                    className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                    style={{
                                        width: '100%',
                                        maxHeight: '100px',
                                        overflowY: 'auto'
                                    }}
                                >
                                    <div className="py-1">
                                        {
                                            recepientArray.map((recepientSelect, index) => (
                                                <MenuItem key={index}>
                                                    <button
                                                        className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                        onClick={() => {
                                                            setEmailcomposeDetails((prev) => ({
                                                                ...prev,
                                                                toRole: recepientSelect,
                                                                to: (recepientSelect === "Penpal") ? recepientMails.penpal : (recepientSelect === "Teacher" ? recepientMails.teacher : recepientMails.admin)
                                                            }));
                                                        }}
                                                    >
                                                        {recepientSelect}
                                                    </button>
                                                </MenuItem>
                                            ))
                                        }
                                    </div>
                                </MenuItems>
                            </Menu>
                        </div>

                        {errors.noToRole &&
                            <div className="flex items-center justify-center w-full">
                                <div className="w-full md:w-[600px]">
                                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t221')}</p>
                                </div>
                            </div>
                        }

                    </>
                }

                {
                    isSubjectNew &&
                    <div className="flex items-center justify-center">
                        <div className="mb-[10px] w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                            <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                            <input value={emailcomposeDetails.subject.trim() === "" && !isSubjectNew ? "(No subject)" : emailcomposeDetails.subject} disabled={!isSubjectNew} type="text" name="subject" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t224')}
                                onChange={(e) => {
                                    setEmailcomposeDetails((prevState) => ({
                                        ...prevState, subject: e.target.value
                                    }))
                                }}
                            />
                        </div>
                    </div>
                }


                {
                    files &&
                    <>
                        {
                            files.length > 0 &&
                            <> <div className="md:flex md:justify-center md:items-center mb-[20px]">
                                <div className="mt-[20px] flex flex-col gap-[5px] mb-[10px] w-full md:w-[600px]">
                                    {files.map((file, index) => (
                                        <div key={index} className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                <MdFilePresent />
                                                <p className="text-black text-[15px] md:text-[17px]">{file.fileName || file.name}</p>
                                            </div>
                                            <div className="pr-[10px]">
                                                <MdClose onClick={() => removeFile(file)} className="cursor-pointer" />
                                            </div>
                                        </div>
                                    )
                                    )
                                    }
                                </div>
                            </div>
                            </>
                        }
                    </>
                }


                {
                    showOCRoptions &&
                    <div className="md:flex md:justify-center md:items-center">
                        <div className="flex gap-[10px] items-center justify-end w-full md:w-[600px]">

                            <div>
                                <div className="relative md:hidden">
                                    <button onClick={() => mobileOCRFileInputRef.current?.click()} className={` bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533] ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} px-[20px] py-[10px] md:py-[5px] 2xl:py-[10px] rounded-md`}>{t('t282')}</button>
                                    <input
                                        ref={mobileOCRFileInputRef}
                                        type="file"
                                        multiple={false}
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handleFileUpload}
                                    />
                                </div>
                                <div className="relative hidden md:block">
                                    <button onClick={() => desktopOCRFileInputRef.current?.click()} className={` bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} px-[20px] py-[10px] md:py-[5px] xl:py-[15px] rounded-md`}>{t('t282')}</button>
                                    <input
                                        ref={desktopOCRFileInputRef}
                                        type="file"
                                        accept="image/*"
                                        multiple={false}
                                        className="hidden"
                                        onChange={handleFileUpload}
                                    />
                                </div>
                            </div>


                            {
                                isMobileDevice() &&
                                <div>
                                    <button onClick={openCamera} className={` bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} px-[20px] py-[10px] md:py-[5px] 2xl:py-[10px] rounded-md `}>{t('t436')}</button>
                                </div>
                            }
                        </div>
                    </div>

                }

                <div className="w-full flex items-center justify-center">
                    <div className="w-full md:w-[600px]">
                        <div className="justify-center items-center">
                            <ReactQuill
                                value={emailcomposeDetails.body}
                                onChange={handleChange}
                                modules={modules}
                                theme="snow"
                                // placeholder={t('t172')}
                                className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                        </div>
                    </div>
                </div>

                {errors.noBody &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t226')}</p>
                        </div>
                    </div>
                }


                {errors.wordLimitExceeded &&
                    <div className="flex items-center justify-center w-full">
                        <div className="w-full md:w-[600px]">
                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t469')}</p>
                        </div>
                    </div>
                }

            </div>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open3}
                onClose={handleClose3}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t218')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t215')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose3}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t217')}
                    </Button>
                    <Button
                        onClick={saveDraft}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t216')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open4}
                onClose={handleClose4}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t275')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose4}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openDraft}
                onClose={handleCloseDraft}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t408')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseDraft}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={open5}
                onClose={handleClose5}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t276')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose5}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open10}
                onClose={handleClose10}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t277')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose10}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    modal: {
        background: "white",
        padding: "20px",
        borderRadius: "12px",
        width: "90%",
        height: "60%",
        maxWidth: "600px",
        textAlign: "center",

    }
};

export default EmailCompose;